import type { TFunction } from 'i18next';
import { ItemHealthLevel } from '@/common/api/types/dashboard/health';

export const getHealthLevelLabel = (healthLevel: ItemHealthLevel, t: TFunction): string => {
  switch (healthLevel) {
    case ItemHealthLevel.ACTION_REQUIRED:
      return t(($) => $.insights.ragStatus.ACTION_REQUIRED);
    case ItemHealthLevel.NEEDS_ATTENTION:
      return t(($) => $.insights.ragStatus.NEEDS_ATTENTION);
    case ItemHealthLevel.HEALTHY:
      return t(($) => $.insights.ragStatus.HEALTHY);
    case ItemHealthLevel.DONE:
      return t(($) => $.insights.ragStatus.DONE);
    default: {
      // Compile-time error if a new ItemHealthLevel value is added without a case
      const _exhaustiveCheck: never = healthLevel;
      return String(_exhaustiveCheck);
    }
  }
};
